import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

interface OnboardingProgressProps {
  step: number;
  total: number;
}

export function OnboardingProgress({ step, total }: OnboardingProgressProps) {
  return (
    <div data-testid="onboarding-progress" className="flex flex-col gap-2.5">
      <div className="flex gap-2">
        {Array.from({ length: total }, (_, i) => {
          const filled = i < step;
          return (
            <div
              key={i}
              data-testid={`onboarding-progress-segment-${i + 1}`}
              className={cn(
                "h-1.5 flex-1 overflow-hidden rounded-full border",
                filled ? "border-safety" : "border-cad/60",
              )}
            >
              <motion.div
                className="h-full bg-safety"
                initial={{ scaleX: 0 }}
                animate={{ scaleX: filled ? 1 : 0 }}
                transition={{ delay: 0.2 + i * 0.1, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                style={{ originX: 0 }}
              />
            </div>
          );
        })}
      </div>
      <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-cad">
        Step {String(step).padStart(2, "0")} / {String(total).padStart(2, "0")}
      </span>
    </div>
  );
}
